import DatePicker from '../../../components/Misc/DatePicker';
import Input from '../../../components/UIElements/Input';

const OrderSearchModalContent = ({ onChange, formData, onCancel, onSubmit }) => {

  return (
    <div className="md:px-17.5 w-full max-w-230 rounded-lg bg-white px-8 py-12 dark:bg-boxdark md:py-15">
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/3">
          <Input
            placeholder="The SeatScouts ID of the order"
            label="ID"
            name="id"
            onChange={onChange}
            value={formData.id}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <Input
            placeholder="Partial match on event name"
            label="Event Name"
            name="event_name"
            onChange={onChange}
            value={formData.event_name}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <Input
            label="Venue Name"
            placeholder="Partial match on venue name"
            name="venue_name"
            onChange={onChange}
            value={formData.venue_name}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/3">
          <DatePicker
            label="Order updated at greater than"
            value={formData.updated_at}
            onChange={onChange}
            name="updated_at"
          />
        </div>
        <div className="w-full xl:w-1/3">
          <DatePicker
            label="Order date no earlier than"
            value={formData.order_date_from}
            onChange={onChange}
            name="order_date_from"
          />
        </div>
        <div className="w-full xl:w-1/3">
          <DatePicker
            label="Order date no later than"
            value={formData.order_date_to}
            onChange={onChange}
            name="order_date_to"
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/3">
          <DatePicker
            label="Event date no earlier than "
            value={formData.event_date_from}
            onChange={onChange}
            name="event_date_from"
          />
        </div>
        <div className="w-full xl:w-1/3">
          <DatePicker
            label="Event date no later than"
            value={formData.event_date_to}
            onChange={onChange}
            name="event_date_to"
          />
        </div>
        <div className="w-full xl:w-1/3">
          <Input
            label="Transfer Email"
            placeholder="Partial match on transfer email"
            name="transfer_email"
            onChange={onChange}
            value={formData.transfer_email}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/3">
          <Input
            placeholder="Order ticket section"
            label="Section"
            name="section"
            onChange={onChange}
            value={formData.section}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <Input
            placeholder="Order ticket row"
            label="Row"
            name="row"
            onChange={onChange}
            value={formData.row}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <Input
            label="Order ID"
            placeholder="Marketplace order ID"
            name="order_id"
            onChange={onChange}
            value={formData.order_id}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/3">
          <Input
            placeholder="Order status (pending, problem, confirmed, confirmed_delay, delivery_problem, delivered)"
            label="Status"
            name="status"
            onChange={onChange}
            value={formData.status}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <Input
            placeholder="Delivery or stock type (barcode, flash, paper, mobile, pdf, mobile_qr) you can pass several separated by comma"
            label="Delivery"
            name="delivery"
            onChange={onChange}
            value={formData.delivery}
          />
        </div>
        <div className="w-full xl:w-1/3">
          <Input
            label="Marketplace"
            placeholder="Marketplace (axs, fanxchange, gametime, seatgeek, stubhub, ticket_evo, ticket_network_mp, ticketmaster, tickpick, vividseats) you can pass several separated by comma"
            name="marketplace"
            onChange={onChange}
            value={formData.marketplace}
          />
        </div>
      </div>
      <div className="-mx-3 flex flex-wrap gap-y-4">
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onCancel}
            className="block w-full rounded border border-stroke bg-gray p-3 text-center font-medium text-black transition hover:border-meta-1 hover:bg-meta-1 hover:text-white dark:border-strokedark dark:bg-meta-4 dark:text-white dark:hover:border-meta-1 dark:hover:bg-meta-1"
          >
            Cancel
          </button>
        </div>
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onSubmit}
            className="block w-full rounded border border-primary bg-primary p-3 text-center font-medium text-white transition hover:bg-opacity-90"
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};
export default OrderSearchModalContent;
